module.exports = __webpack_public_path__ + "static/img/balzmk83.e268168.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/balzmk83.jpg
// module id = 2CRB
// module chunks = 0